import PublicWebsiteConstants from "../Constants/PublicWebsiteConstants";
import dispatcher from "../Dispatcher/Dispatcher";
import config from "./../Config/Config";
import httpRequest from "./../HttpRequests/HttpRequest";
class PublicWebsiteActions {
  getConfigurationOptPublicWebsite(anlagegruppeID) {
    httpRequest(
      config.webServiceURL + "/PublicWebsite/GetConfiguraton/" + anlagegruppeID,
      "GET",
      null,

      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: PublicWebsiteConstants.GET_CONFIGURATION_OPTION_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: PublicWebsiteConstants.GET_CONFIGURATION_OPTION_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  saveORupadateConfigurationOption(_dataObject) {
    httpRequest(
      config.webServiceURL + "/PublicWebsite/Post",
      "POST",
      JSON.stringify({
        ..._dataObject,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: PublicWebsiteConstants.SAVE_UPDATE_CONFIGURATION_OPTION_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: PublicWebsiteConstants.SAVE_UPDATE_CONFIGURATION_OPTION_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  GetEquipmentPublicInformationBytag(tagId, language) {
    httpRequest(
      config.webServiceURL +
        "/PublicWebsite/GetEquipmentPublicInformationBytag/" +
        tagId +
        "?Language=" +
        language,
      "GET",
      null,

      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: PublicWebsiteConstants.GET_EQUIPMENT_PUBLIC_INFO_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: PublicWebsiteConstants.GET_EQUIPMENT_PUBLIC_INFO_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  downloadDocument(documentId, documentName) {
    httpRequest(
      config.webServiceURL + "/PublicWebsite/OpenDocument/" + documentId,
      "GET",
      null,
      (res, message) => {
        if (res !== "Error") {
          const url = window.URL.createObjectURL(res);
          let a = document.createElement("a");

          a.href = url;
          //a.target="_blank" ;
          a.download = documentName;

          a.click();

          window.URL.revokeObjectURL(url);

          dispatcher.dispatch({
            type: PublicWebsiteConstants.DOWNLOAD_DOC_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: PublicWebsiteConstants.DOWNLOAD_DOC_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  CreateTicket(_dataObject) {
    httpRequest(
      config.webServiceURL + "/Ticket",
      "POST",
      JSON.stringify({
        ..._dataObject,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: PublicWebsiteConstants.CREATE_TICKET_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: PublicWebsiteConstants.CREATE_TICKET_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  GetDistinctTitles(equipmentGroupId) {
    httpRequest(
      config.webServiceURL + "/Ticket/GetDistinctTitles/" + equipmentGroupId,
      "GET",
      null,

      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: PublicWebsiteConstants.GET_TITLE_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: PublicWebsiteConstants.GET_TITLE_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  GetTitleDescription(equipmentGroupId, title) {
    httpRequest(
      config.webServiceURL +
        "/Ticket/GetTitleDescription/" +
        equipmentGroupId +
        "/" +
        title,
      "GET",
      null,

      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: PublicWebsiteConstants.GET_TITLE_DESCRIPTION_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: PublicWebsiteConstants.GET_TITLE_DESCRIPTION_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  GetEqupGroupConfiguration(anlageId) {
    httpRequest(
      config.webServiceURL +
        "/PublicWebsite/GetEquipmentPublicInformation/" +
        anlageId,
      "GET",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: PublicWebsiteConstants.GET_EQUIP_GRP_CONF_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: PublicWebsiteConstants.GET_EQUIP_GRP_CONF_FAILURE,
            result: message,
          });
        }
      }
    );
  }
}

export default new PublicWebsiteActions();
